import { useParams, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { paymentsService } from '../services/payments.service';
import appAxios from '../services/axios';

export const OrderPayments = () => {
    const { orderID } = useParams();
    const [searchParams] = useSearchParams();
    const type = searchParams.get('type');
    const [prepaymentForm, setPrepaymentForm] = useState();

    useEffect(() => {
        const doPrePayment = async () => {
            try {
                // const html = await paymentsService.create(orderID, type);                
                window.location.href = appAxios.defaults.baseURL + '/app/bcc/payments/create?orderID=' + orderID + '&type=' + type;
                
            } catch (error) {
                console.log(error);
            }
        }
        doPrePayment();
    }, [orderID, type]);

    return (
        <div>
            <h1>Предоплата</h1>
            <div dangerouslySetInnerHTML={{ __html: prepaymentForm }} />
        </div>
    )
}
